module.exports = __webpack_public_path__ + "img/curtain_up_70.f271eb29.svg";